import useRegisterDiagnosticChecklist from "routes/home/my-courses/common/diagnostics/useRegisterDiagnosticChecklist.ts";
import { DiagnosticChecklist } from "routes/home/my-courses/common/diagnostics/diagnosticChecklistTypes.ts";
import { CourseMaterial, useCoursesLoaderData } from "./coursesLoader.ts";

function buildSwapDetail(materials: CourseMaterial[]): string[] {
  return materials.map(
    (material) =>
      `${material.isbn}: ePOS → open_book (vbid ${material.alternateAccessVbid})`
  );
}

function buildChecklist(swapped: CourseMaterial[]): DiagnosticChecklist {
  return {
    id: "alternate-access",
    title: "Alternate Digital Access",
    items: [
      {
        // Decimal returns an ePOS purchase link for these materials. The
        // loader replaces it, so the response and the buttons disagree by
        // design.
        label: "Purchase prompt replaced with Open Book",
        status: "info",
        detail: swapped.length > 0 ? buildSwapDetail(swapped) : ["none"],
      },
    ],
  };
}

// Reads the same materials the cards render, so a diagnostic cannot disagree
// with the page.
export default function useAlternateAccessDiagnostics() {
  const { allMaterials } = useCoursesLoaderData();

  useRegisterDiagnosticChecklist(
    buildChecklist(
      allMaterials.filter((material) => material.alternateAccessVbid)
    )
  );
}
